<template>
  <div class="wrapper">
    <v-icon small color="black">far fa-clock</v-icon>
    <VueTimepicker
      v-model="_time"
      :minute-interval="interval"
      format="HH:mm"
      hide-clear-button
    />

  </div>
</template>

<script>
import VueTimepicker from 'vue2-timepicker';
import 'vue2-timepicker/dist/VueTimepicker.css'

export default {
  components: {
    VueTimepicker
  },
  props: {
    value: String
  },
  data: () => ({
    interval: 1
  }),
  computed: {
    _time: {
      get() {
        if (!this.value) {
          return { HH: '00', mm: '00' };
        } else {
          return { HH: this.value.split(':')[0], mm: this.value.split(':')[1] };
        }
      },
      set(val) {
        this.$emit('input', val.HH + ':' + val.mm);
      }
    }
  }
};
</script>

<style lang="stylus" scoped>
.v-icon
  margin 2px 2px 0px 0px

.wrapper
  margin: 15px 10px
  min-width  200px

.time-picker >>> input[type=text]
  height 35px
  width 60px
  padding: 7px 10px 7px 7px;
  border: 1px #a0a0a0 solid;
  border-radius: 2px;

.time-picker >>> input[type=text]:hover
  cursor: pointer;
</style>
